import { DeliveryZoneRow } from '../../delivery-zones/types/delivery-zone.type';

const hasCharges = (zone: DeliveryZoneRow): boolean => zone.charges.length > 0;

export const sortDeliveryZoneOptions = (zones: DeliveryZoneRow[]): DeliveryZoneRow[] => [
  ...zones.filter(hasCharges),
  ...zones.filter((zone) => !hasCharges(zone)),
];
